<template>
  <div class="logoff_box">
    <!-- <div class="title">{{$t('logoff.text10')}}</div> -->
    <div class="logoff_box_content"
         v-html="content">
    </div>
    <!-- <p>{{$t('logoff.logoffTipsText1')}}</p>
      <p>{{$t('logoff.logoffTipsText2')}}</p>
      <p>{{$t('logoff.logoffTipsText3')}}</p> -->
    <div class="logoff_button"
         @click="gotoagreement">{{$t('logoff.buttonText')}}</div>
  </div>
</template>

<script>
import { del_user_submit, get_game_all, agreement } from '@/api/init'
import { appPostMessage } from '@/utils/communication'
import { getSessionStorage, setSessionStorage } from '../../utils/stage'
export default {
  data() {
    return {
      tipsName: '',
      tipsFlag: false,
      linkUrl: '/',
      accountInfo: '',
      text1: this.$t('logoff.text1'),
      configData: '',
      flag: false,
      content: '',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.configData = JSON.parse(getSessionStorage('message'))
      const msg = Object.assign(JSON.parse(JSON.stringify(this.configData)), {
        type: 8,
      })
      agreement(msg).then((res) => {
        this.content = this.place(res.data.content)
      })
    },
    close() {
      this.tipsFlag = false
    },
    close1() {
      this.tipsFlag = false
      this.$router.push('/home')
    },
    golink() {
      this.tipsFlag = false
    },
    gotoagreement() {
      this.$router.push('/touristLogAgreement')
    },
    closeBtn() {
      const appmsg = { code: 18, data: '' }
      appPostMessage(appmsg)
    },
    placechange(data) {
      const content = data
        .replace(/<e>/g, '<div  style="width:100%;text-align:center;">')
        .replace(/<\/e>/g, '</div>')
        .replace(/<dt>/g, '<a>')
        .replace(/<\/dt>/g, '</a>')
        .replace(/<red>/g, '<span style="color:red;">')
        .replace(/<\/red>/g, '</span>')
        .replace(/<b>/g, '<stong style=" font-weight: 700;color:#575757;">')
        .replace(/<\/b>/g, '</stong>')
        .replace(/\n/g, '</br>')
      return content
    },
    regplace(data) {
      let dataMsg = data
      let dataArr = []
      var n = dataMsg.match(/<dt>([\s\S]*?)<\/dt><dd>([\s\S]*?)<\/dd>/g)
      for (const i in n) {
        const a = n[i].match(/<dt>([\s\S]*?)<\/dt>/)
        const b = n[i].match(/<dd>([\s\S]*?)<\/dd>/)
        const ahmtr = `<a href="#/agreementInfo?text=${i}" style="text-decoration:underline;color:blue;">${a[1]} </a>`
        dataMsg = dataMsg.replace(a[0], ahmtr)
        dataMsg = dataMsg.replace(b[0], '')
        const arr = {
          name: a[1],
          value: b[1],
        }
        dataArr.push(arr)
      }
      return dataMsg
    },
    place(data) {
      const regplaceData = this.regplace(data)
      const content_string = this.placechange(regplaceData)
      return content_string
    },
  },
}
</script>

<style lang="less" scope>
.logoff_box {
  height: 100%;
  padding: 30/75rem;
  position: relative;
  box-sizing: border-box;
  .title {
    font-size: 28/75rem;
    font-weight: bold;
    color: #575757;
    margin-bottom: 20/75rem;
  }
  .logoff_box_content {
    height: 70vh;
    font-size: 28/75rem;
    font-weight: 400;
    color: #707070;
    p {
      margin-bottom: 20/75rem;
    }
  }
  .logoff_button {
    position: absolute;
    width: 690/75rem;
    height: 76/75rem;
    background: #ff7391;
    border-radius: 6/75rem 6/75rem 6/75rem 6/75rem;
    left: 50%;
    transform: translateX(-50%);
    bottom: 60/75rem;
    font-size: 30/75rem;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    line-height: 76/75rem;
    text-align: center;
    color: #fff;
  }
  .logoff_tips_mosk {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    .logoff_tips_close {
      width: 100%;
      height: 100%;
      position: absolute;
    }
    .logoff_tips_box {
      width: 560/75rem;
      height: 364/75rem;
      background: #ffffff;
      border-radius: 16/75rem 16/75rem 16/75rem 16/75rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      padding: 30/75rem;
      box-sizing: border-box;
      h3 {
        font-size: 34/75rem;
        font-weight: 400;
        text-align: center;
        margin-bottom: 40/75rem;
      }
      p {
        text-align: center;
        // margin-top: 20/75rem;
        font-size: 26/75rem;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #646464;
      }
      .golink {
        width: 500/75rem;
        height: 86/75rem;
        background: #ff7391;
        border-radius: 6/75rem 6/75rem 6/75rem 6/75rem;
        text-align: center;
        line-height: 86/75rem;
        position: absolute;
        bottom: 30/75rem;
        left: 50%;
        font-size: 28/75rem;
        color: #fff;
        transform: translateX(-50%);
      }
    }
  }
}
</style>